<script setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import CardLayout from 'dashboard/components-next/CardLayout.vue';

const props = defineProps({
  product: { type: Object, required: true },
});

const router = useRouter();

const label = computed(
  () => props.product.name || props.product.sku || `#${props.product.id}`
);

const navigateTo = () => {
  router.push({
    name: 'web_order_products',
    query: { q: props.product.sku || props.product.name || '' },
  });
};
</script>

<template>
  <button type="button" class="w-full text-left" @click="navigateTo">
    <CardLayout
      layout="row"
      class="[&>div]:items-start [&>div]:justify-start [&>div]:px-4 [&>div]:py-3 hover:bg-n-slate-2 dark:hover:bg-n-solid-3"
    >
      <span
        class="i-lucide-package mt-0.5 block size-4 shrink-0 text-n-slate-11"
        aria-hidden="true"
      />
      <div class="flex min-w-0 flex-1 flex-col gap-1">
        <h5 class="min-w-0 truncate py-1 text-sm font-medium text-n-slate-12">
          {{ label }}
        </h5>
        <p v-if="product.sku" class="truncate text-sm text-n-slate-11">
          {{ product.sku }}
        </p>
      </div>
    </CardLayout>
  </button>
</template>
